import { LearnLayout } from "./Layout/LearnLayout";

export const RoadmapsLearn = () => {
  return (
    <LearnLayout videoUrl="https://www.loom.com/embed/5ac4488247d049468289c017c7eee373?sid=c36b9cd6-cd6a-4079-bddb-bceead7f1287">
      <h3>Roadmaps</h3>
      <p>
        If you ask members of your team, "Where are we heading?", you're bound
        to get different answers. But if you were to push one level deeper with
        "What do we need to achieve in the next year?", what are the chances
        you'd hear the same answer?
      </p>
      <p>
        When you take a bird's-eye view of your company, your team seems
        synchronized like a well-oiled machine, pushing in the same direction.
        However, a closer look reveals that everyone is rowing at different
        speeds and, more concerning, in different directions.
      </p>
      <p>That's exactly where a company roadmap comes in.</p>
      <h4>What Is It</h4>
      <p>
        A comprehensive forward look at a company's future that acknowledges
        three critical questions:
      </p>
      <p>Where are we going? Why? By when?</p>
      <h4>How It Works</h4>
      <p>
        1. Start with your peak ambition: Think about the mountaintop for your
        company 5-10 years from today. What does it look like? What are you
        working toward?
      </p>
      <p>
        2. Play the movie backward: Once you have a clear destination in mind,
        ask yourself, "What must be true 3 years out, 1 year out, next quarter,
        etc., to achieve my peak ambition?"
      </p>
      <p>
        3. Define what's needed to make this ambition a reality: Get more
        specific and picture the key milestones along your journey. For example,
        the targets regarding revenue, product, market position, work
        environment, etc.?
      </p>
      <h4>The Result</h4>
      <p>When your team understands the destination and why it matters:</p>
      <p>1. Everyone makes aligned decisions, regardless of your presence.</p>
      <p>2. Time and resources all point toward your shared destination.</p>
      <p>3. Your team will move forward with a coordinated purpose.</p>
      <h4>How Vojomo Helps</h4>
      <p>
        Start by telling Vo about your peak ambition in as much detail as you'd
        like. You can check out the video for a deeper dive into company roadmap
        building and how to get the most out of the Vojomo app.
      </p>
    </LearnLayout>
  );
};
